module.exports = __webpack_public_path__ + "img/ic_1.72c038bf.png";